import React from 'react'
import './Projects.css'
import { featured_projects } from '../../data/featured_projects.json'
import Section from '../section/Section'
import FeaturedProject from '../featuredProject/FeaturedProject'
import { useScrollReveal } from '../../hooks/useScrollReveal'

const Projects = () => {
  const listRef = useScrollReveal({ y: 25, stagger: 0.12 })
  const ctaRef = useScrollReveal({ y: 20 })

  return (
    <Section title="Alguns projetos que fiz parte" stage="projetos">
      <div className="projects-content">
        <div className="file-card">
          <div className="file-card-bar">
            <span className="file-card-dot" aria-hidden="true" />
            repositorios/
          </div>
          <ul className="projects-list" ref={listRef}>
            {featured_projects.map((featuredProject) => {
              return (
                <li
                  key={`featured-project-${featuredProject.id}`}
                  data-reveal-item
                >
                  <FeaturedProject
                    name={featuredProject.name}
                    link={featuredProject.link}
                    description={featuredProject.description}
                    colour={featuredProject.colour}
                    languages={featuredProject.languages}
                  />
                </li>
              )
            })}
          </ul>
        </div>
        <div ref={ctaRef} className="more-projects-wrapper">
          <p style={{ textAlign: 'center' }}>
            Mais projetos no meu{' '}
            <a
              href="https://github.com/jardersilva"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: 'none',
                color: 'var(--accent)',
                fontWeight: 600,
              }}
            >
              GitHub
            </a>
          </p>
        </div>
      </div>
    </Section>
  )
}

export default Projects
